import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';

import Framework from '@beardeddevops/react.framework';

import Header from 'components/Header';
import Sidenav from 'components/Sidenav';
import Footer from 'components/Footer';
import Parts from 'components/Parts';

import Accolades from '../routes/accolades';
import Admin from '../routes/admin/';
import Managers from '../routes/managers/';
import Dispatch from '../routes/dispatch/';
import OutstandingInvoices from '../routes/outstanding_invoices/';
import DataEntry from '../routes/dataEntry/';
import Engineers from '../routes/engineers/';
import Forms from '../routes/forms'
import HelpDesks from '../routes/help_desks'
import Hiring from '../routes/hiring'
import Tickets from '../routes/tickets/';
import Time_Off from "../routes/time_off";
import Business_Cards from "../routes/business_cards";
import Pay_Center from "../routes/pay_center";
import Pay_Center_Admin from "../routes/pay_center_admin";
import Copyables from "../routes/copyables";
import Videos from "../routes/videos";
import Projects from "../routes/projects";
import Customers from '../routes/customers/';
import Regions from '../routes/regions/';
import Users from '../routes/users/';
import PhoneLog from '../routes/phone_log/'
import Stripe from '../routes/stripe/'
import Financial from "../routes/financial";
import Time_Tracking from "../routes/time_tracking"
import Scores from "../routes/Scores"
import Feedback from "../routes/feedback"
import Refunds from "../routes/refunds"
import Executives from "../routes/executives";
import Schedule_Approvals from "../routes/schedule_approvals";
import Links from "../routes/links";
// import Idle_Tasks from "../routes/idle_tasks";

import UserRoles from "constants/UserRoles";
import ErrorBoundaryRoute from '../../../containers/ErrorBoundaryRoute';

export default class MainApp extends React.Component {
	reloadShell = () => {
		console.log('Reloading Shell');
		this.props.rootState.triggerAction('getUserInformation', {fromRouteChange: false, forceTrigger: false});
	}

	render() {
		const {match, rootState} = this.props;
		let {
			name,
			account,
			regions,
			roles,
			showSideBar,
			user,
			main_role
		} = rootState;

		return (
			<div className={"main-app-container"}>

				<Sidenav regions={regions} roles={roles} history={this.props.history} badges={this.props.badges}/>

				<section id="page-container" className={"app-page-container"}>
					<Header
						roles={roles}
						regions={regions}
						history={this.props.history}
						name={name}
						reloadShell={this.reloadShell}
						toggle={showSideBar}
						account = {user}
						thermometer_data={this.props.thermometer_data}
						active={this.props.active}
						notifications={this.props.notifications}
						// grade_score_hour={this.props.grade_score_hour}
						// grade_score_day={this.props.grade_score_day}
					/>

					<div className="app-content-wrapper">
						<div className="app-content">
							<div className="app-banner-stack">
								<Parts.HelpdeskCallBanner
									notifications={this.props.notifications}
									history={this.props.history}
									roles={roles}
									mainRole={main_role}
									onSessionCheck={() => rootState.triggerAction('handleSessionCheck')}
								/>
								<Parts.HelpdeskCallModal
									notifications={this.props.notifications}
									history={this.props.history}
									roles={roles}
									mainRole={main_role}
									onSessionCheck={() => rootState.triggerAction('handleSessionCheck')}
								/>
								<Parts.MissingFinancialBanner
									notifications={this.props.notifications}
									history={this.props.history}
								/>
							</div>
							<div className="full-height">
								<Switch>
									{roles.includes(UserRoles.Onboarding) &&
										<ErrorBoundaryRoute path={`${match.url}dataEntry`}>
											<DataEntry
												account={account}
												regions={regions}
												reloadShell={this.reloadShell}
												roles={roles}
												user={user}
											/>
										</ErrorBoundaryRoute>}
									{roles.includes(UserRoles.Admin) &&
									<ErrorBoundaryRoute path={`${match.url}admins`}>
										<Admin
											account={account}
											regions={regions}
											reloadShell={this.reloadShell}
											roles={roles}
										/>
									</ErrorBoundaryRoute>}
									{roles.some(role => [UserRoles.Admin, UserRoles.Executive].includes(role)) &&
										<ErrorBoundaryRoute path={`${match.url}executives`}>
											<Executives
												account={account}
												regions={regions}
												reloadShell={this.reloadShell}
												roles={roles}
											/>
										</ErrorBoundaryRoute>}
									{roles.some(role => [UserRoles.Admin, UserRoles.Manager].includes(role)) &&
									<ErrorBoundaryRoute path={`${match.url}managers`}>
										<Managers
											regions={regions}
	                                        account={account}
	                                        reloadShell={this.reloadShell}
											main_role={main_role}
	                                        roles={roles} />
									</ErrorBoundaryRoute>
									}
									{roles.some(role => [UserRoles.Admin, UserRoles.Executive, UserRoles.Manager, UserRoles.Collection].includes(role)) &&
										<ErrorBoundaryRoute path={`${match.url}collections`}>
											<OutstandingInvoices
												account={account}
												regions={regions}
												reloadShell={this.reloadShell}
												roles={roles}
											/>
										</ErrorBoundaryRoute>}
									{roles.some(role => [UserRoles.Admin, UserRoles.Feedback].includes(role)) &&
										<ErrorBoundaryRoute path={`${match.url}feedback`}>
											<Feedback
												regions={regions}
												account={account}
												reloadShell={this.reloadShell}
												roles={roles} />
										</ErrorBoundaryRoute>
									}
									{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.HelpDesk].includes(role)) &&
									<ErrorBoundaryRoute path={`${match.url}dispatch`}>
										<Dispatch
											account={account}
											regions={regions}
											reloadShell={this.reloadShell}
											roles={roles}
										/>
									</ErrorBoundaryRoute>}
									{roles.includes(UserRoles.FieldEngineer) &&
									<ErrorBoundaryRoute path={`${match.url}engineers`}>
										<Engineers
											account={account}
											regions={regions}
											reloadShell={this.reloadShell}
											roles={roles}
											currentFE={this.props.rootState.name}
											user={user}
										/>
									</ErrorBoundaryRoute>}

									<ErrorBoundaryRoute path={`${match.url}kt_forms`}>
										<Forms
											account={account}
											regions={regions}
											reloadShell={this.reloadShell}
											roles={roles}
										/>
									</ErrorBoundaryRoute>

									{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.FieldEngineer, UserRoles.Developer, UserRoles.HelpDesk].includes(role)) &&
									<ErrorBoundaryRoute path={`${match.url}helpdesks`}>
										<HelpDesks
											account={account}
											reloadShell={this.reloadShell}
											roles={roles}
										/>
									</ErrorBoundaryRoute>}

									{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.FieldEngineer, UserRoles.Developer, UserRoles.HelpDesk, UserRoles.Hiring].includes(role)) &&
										<ErrorBoundaryRoute path={`${match.url}hiring`}>
											<Hiring
												account={account}
												reloadShell={this.reloadShell}
												roles={roles}
											/>
										</ErrorBoundaryRoute>}

									{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.FieldEngineer, UserRoles.Developer, UserRoles.HelpDesk].includes(role)) &&
									<ErrorBoundaryRoute path={`${match.url}tickets`}>
										<Tickets
											account={account}
											regions={regions}
											reloadShell={this.reloadShell}
											roles={roles}
										/>
									</ErrorBoundaryRoute>}
									{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.FieldEngineer, UserRoles.Developer, UserRoles.HelpDesk].includes(role)) &&
									<ErrorBoundaryRoute path={`${match.url}customers`}>
										<Customers
											account={account}
											regions={regions}
											reloadShell={this.reloadShell}
											roles={roles}
										/>
									</ErrorBoundaryRoute>}
									{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.Executive, UserRoles.HelpDesk].includes(role)) &&
										<ErrorBoundaryRoute path={`${match.url}refunds`}>
											<Refunds
												account={account}
												regions={regions}
												reloadShell={this.reloadShell}
												roles={roles}
											/>
										</ErrorBoundaryRoute>}
									{roles.includes(UserRoles.Admin) &&
									<ErrorBoundaryRoute path={`${match.url}regions`}>
										<Regions
											account={account}
											regions={regions}
											reloadShell={this.reloadShell}
											roles={roles}
										/>
									</ErrorBoundaryRoute>}
									{
										//Adding all roles to /users lets the User index handle rerouting, that way everyone can get to their own user settings
									}
									{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.FieldEngineer, UserRoles.Developer, UserRoles.HelpDesk, UserRoles.Hiring, UserRoles.Financial, UserRoles.Executive, UserRoles.Projects, UserRoles.TORManager, UserRoles.Onboarding].includes(role)) &&
									<ErrorBoundaryRoute path={`${match.url}users`}>
										<Users
											account={account}
											regions={regions}
											reloadShell={this.reloadShell}
											roles={roles}
										/>
									</ErrorBoundaryRoute>}
									{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.HelpDesk].includes(role)) &&
									<ErrorBoundaryRoute
										path={`${match.url}phone`}>
										<PhoneLog
											regions={regions}
											account={account}
											reloadShell={this.reloadShell}
											roles={roles}
										/>
									</ErrorBoundaryRoute>}
									<ErrorBoundaryRoute
										path={`${match.url}stripe`}>
										<Stripe
											regions={regions}
											account={account}
											reloadShell={this.reloadShell}
											roles={roles}
										/>
									</ErrorBoundaryRoute>
									<ErrorBoundaryRoute
										path={`${match.url}schedule_adjust`}>
										<Time_Off
											regions={regions}
											account={account}
											reloadShell={this.reloadShell}
											roles={roles}
											user={user}
											main_role={main_role}
										/>
									</ErrorBoundaryRoute>
									{roles.some(role => [UserRoles.Admin, UserRoles.FieldEngineer, UserRoles.Executive].includes(role)) &&
									<ErrorBoundaryRoute
										path={`${match.url}business_cards`}>
										<Business_Cards
											regions={regions}
											account={account}
											reloadShell={this.reloadShell}
											roles={roles}
											user={user}
											main_role={main_role}
										/>
									</ErrorBoundaryRoute>}
									<ErrorBoundaryRoute
										path={`${match.url}links`}>
										<Links
											regions={regions}
											account={account}
											reloadShell={this.reloadShell}
											roles={roles}
											user={user}
											main_role={main_role}
										/>
									</ErrorBoundaryRoute>
									{/*<ErrorBoundaryRoute*/}
									{/*	path={`${match.url}idle_tasks`}>*/}
									{/*	<Idle_Tasks*/}
									{/*		regions={regions}*/}
									{/*		account={account}*/}
									{/*		reloadShell={this.reloadShell}*/}
									{/*		roles={roles}*/}
									{/*		user={user}*/}
									{/*		main_role={main_role}*/}
									{/*	/>*/}
									{/*</ErrorBoundaryRoute>*/}
									{roles.some(role => [UserRoles.Dispatch, UserRoles.Hiring, UserRoles.HelpDesk, UserRoles.FieldEngineer].includes(role)) &&
										<ErrorBoundaryRoute
											path={`${match.url}pay_center`}>
											<Pay_Center
												regions={regions}
												account={account}
												reloadShell={this.reloadShell}
												roles={roles}
												user={user}
												main_role={main_role}
											/>
										</ErrorBoundaryRoute>
									}
									{roles.some(role => [UserRoles.Admin, UserRoles.Financial].includes(role)) &&
										<ErrorBoundaryRoute
											path={`${match.url}pay_center_admin`}>
											<Pay_Center_Admin
												regions={regions}
												account={account}
												reloadShell={this.reloadShell}
												roles={roles}
												user={user}
												main_role={main_role}
											/>
										</ErrorBoundaryRoute>
									}

									{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.Executive].includes(role)) &&
										<ErrorBoundaryRoute
											path={`${match.url}accolades`}>
											<Accolades
												regions={regions}
												account={account}
												reloadShell={this.reloadShell}
												roles={roles}
												user={user}
											/>
										</ErrorBoundaryRoute>}

									{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.FieldEngineer, UserRoles.Developer, UserRoles.HelpDesk].includes(role)) &&
										<ErrorBoundaryRoute
											path={`${match.url}copyables`}>
											<Copyables
												regions={regions}
												account={account}
												reloadShell={this.reloadShell}
												roles={roles}
												user={user}
											/>
										</ErrorBoundaryRoute>}
									{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.FieldEngineer, UserRoles.Developer, UserRoles.HelpDesk].includes(role)) &&
										<ErrorBoundaryRoute
											path={`${match.url}videos`}>
											<Videos
												regions={regions}
												account={account}
												reloadShell={this.reloadShell}
												roles={roles}
												user={user}
											/>
										</ErrorBoundaryRoute>}
									{roles.some(role => [UserRoles.Executive, UserRoles.Admin, UserRoles.Manager, UserRoles.Hiring, UserRoles.HelpDesk, UserRoles.Dispatch, UserRoles.Projects].includes(role)) &&
										<ErrorBoundaryRoute
											path={`${match.url}projects`}>
											<Projects
												regions={regions}
												account={account}
												reloadShell={this.reloadShell}
												roles={roles}
												user={user}
											/>
										</ErrorBoundaryRoute>}
									{roles.some(role => [UserRoles.Dispatch, UserRoles.Hiring, UserRoles.HelpDesk].includes(role)) &&
										<ErrorBoundaryRoute
											path={`${match.url}timetracking`}>
											<Time_Tracking
												regions={regions}
												account={account}
												reloadShell={this.reloadShell}
												roles={roles}
												user={user}
											/>
										</ErrorBoundaryRoute>}

									{roles.some(role => [UserRoles.Dispatch, UserRoles.Hiring, UserRoles.HelpDesk, UserRoles.Admin, UserRoles.Manager, UserRoles.TORManager, UserRoles.Executive, UserRoles.Feedback, UserRoles.Onboarding].includes(role)) &&
										<ErrorBoundaryRoute
											path={`${match.url}schedule_approvals`}>
											<Schedule_Approvals
												regions={regions}
												account={account}
												reloadShell={this.reloadShell}
												roles={roles}
												user={user}
											/>
										</ErrorBoundaryRoute>}

									{roles.some(role => [UserRoles.Dispatch, UserRoles.Admin, UserRoles.Manager].includes(role)) &&
										<ErrorBoundaryRoute
											path={`${match.url}scores`}>
											<Scores
												regions={regions}
												account={account}
												reloadShell={this.reloadShell}
												roles={roles}
												user={user}
											/>
										</ErrorBoundaryRoute>}
									{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.HelpDesk].includes(role)) &&
									<ErrorBoundaryRoute
										path={`${match.url}financial`}>
										<Financial
											regions={regions}
											account={account}
											reloadShell={this.reloadShell}
											roles={roles}
										/>
									</ErrorBoundaryRoute>}

									{roles.includes(UserRoles.Onboarding) && <Redirect to="/dataEntry"/>}
									{roles.includes(UserRoles.Admin) && <Redirect to="/admins"/>}
									{roles.includes(UserRoles.Executive) && <Redirect to="/executives"/>}
									{roles.includes(UserRoles.Manager) && <Redirect to="/managers"/>}
									{roles.includes(UserRoles.Feedback) && <Redirect to="/feedback"/>}
									{roles.includes(UserRoles.HelpDesk) && <Redirect to="/helpdesks"/>}
									{roles.includes(UserRoles.Hiring) && <Redirect to="/hiring/heatmap"/>}
									{roles.includes(UserRoles.Dispatch) && <Redirect to="/dispatch"/>}
									{roles.includes(UserRoles.FieldEngineer) && <Redirect to="/engineers"/>}

								</Switch>
							</div>
						</div>

						<Footer/>
					</div>
				</section>

			</div>
		);
	}
}

MainApp = Framework.Components.withRootState(MainApp);
